export const NoFeedback = () => {
  return (
    <div className="px-20 py-40">
      <div className="text-[#938f9e] text-[17px] font-medium font-['Pretendard Variable'] leading-snug">
        아직 받은 피드백이 없어요!
      </div>
    </div>
  );
};
